import router from "@/router";
import env from "./env";
import wx from "weixin-js-sdk";
import { showToast } from "vant";
import logger from "./logger";

const isBlank = function (str) {
  if (Object.prototype.toString.call(str) === "[object Undefined]") {
    //空
    return true;
  } else if (Object.prototype.toString.call(str) === "[object Number]") {
    return false;
  } else if (
    Object.prototype.toString.call(str) === "[object String]" ||
    Object.prototype.toString.call(str) === "[object Array]"
  ) {
    //字条串或数组
    return str.length == 0 ? true : false;
  } else if (Object.prototype.toString.call(str) === "[object Object]") {
    return JSON.stringify(str) == "{}" ? true : false;
  } else {
    return true;
  }
};

function padStr(i) {
  return String(Number(i)).padStart(2, "0");
}

function formatDateTime(val) {
  if (val != null) {
    var date = new Date(val);
    return (
      date.getFullYear() +
      "-" +
      padStr(date.getMonth() + 1) +
      "-" +
      padStr(date.getDate()) +
      " " +
      padStr(date.getHours()) +
      ":" +
      padStr(date.getMinutes())
    );
  }
}
function formatDate(val) {
  if (val == null) return null;

  // 如果是数组格式，直接使用数组中的值，确保数字类型并进行补零
  if (Array.isArray(val)) {
    const year = Number(val[0]);
    const month = Number(val[1]);
    const day = Number(val[2]);

    if (isNaN(year) || isNaN(month) || isNaN(day)) {
      return null;
    }

    return `${year}-${String(month).padStart(2, "0")}-${String(day).padStart(
      2,
      "0"
    )}`;
  }

  // 如果是字符串，先尝试转换格式
  if (typeof val === "string") {
    // 替换所有可能的分隔符为'-'
    val = val.replace(/[./]/g, "-");
    // 确保使用'-'作为分隔符的格式
    if (!val.includes("-")) {
      return null;
    }
  }

  var date = new Date(val);
  // 检查日期是否有效
  if (isNaN(date.getTime())) {
    return null;
  }

  return (
    date.getFullYear() +
    "-" +
    String(date.getMonth() + 1).padStart(2, "0") +
    "-" +
    String(date.getDate()).padStart(2, "0")
  );
}

function formatDateArray(val) {
  if (val == null) return null;

  // 如果已经是数组格式，直接返回
  if (Array.isArray(val)) {
    return [Number(val[0]), Number(val[1]), Number(val[2])];
  }

  // 如果是字符串，先尝试转换格式
  if (typeof val === "string") {
    // 替换所有可能的分隔符为'-'
    val = val.replace(/[./]/g, "-");
    const parts = val.split("-");
    if (parts.length === 3) {
      return [Number(parts[0]), Number(parts[1]), Number(parts[2])];
    }
  }

  var date = new Date(val);
  // 检查日期是否有效
  if (isNaN(date.getTime())) {
    return null;
  }

  return [date.getFullYear(), date.getMonth() + 1, date.getDate()];
}

function formatDateWithoutYear(val) {
  if (val != null) {
    var date = new Date(val);
    return padStr(date.getMonth() + 1) + "-" + padStr(date.getDate());
  }
}

//H5页面js
function navigate(modelName) {
  //控制页面跳转---小程序、公众号、非微信跳转方式 【modelName---vue路由名字】
  if (env.isWxAppEnv) {
    // 获取当前域名
    var domain = window.location.host;
    var url = "https://" + domain + modelName;
    var redirectUrl = encodeURIComponent(url);
    console.debug("Redirect by wx to: " + redirectUrl);
    wx.miniProgram.navigateTo({
      url: "/pages/WebView/WebView?param=" + redirectUrl,
    });
  } else {
    console.debug("Redirect by router to: " + redirectUrl);
    router.push(modelName); //非小程序页面使用vue路由跳转
  }
}

function callScanQr() {
  console.log("开始调用扫码");

  wx.ready(function () {
    console.log("开始调用checkJsApi");
    wx.checkJsApi({
      //判断当前客户端版本是否支持指定JS接口
      jsApiList: ["scanQRCode"],
      success: function (res) {
        logger.info("checkJsApi success" + res);
        // 以键值对的形式返回，可用true，不可用false。如：{"checkResult":{"scanQRCode":true},"errMsg":"checkJsApi:ok"}
        if (res.checkResult.scanQRCode != true) {
          console.log("抱歉，当前客户端版本不支持扫一扫");
        } else {
          // 调起企业微信扫一扫接口
          wx.scanQRCode({
            desc: "scanQRCode desc",
            needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
            scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
            success: function (res) {
              console.log("调用扫描成功", res);
              var result = res.resultStr; // 获取扫码返回的结果
              if (result) {
                try {
                  // 检查是否是URL
                  if (
                    result.startsWith("http://") ||
                    result.startsWith("https://")
                  ) {
                    // 创建URL对象解析域名
                    const currentHost = window.location.hostname;
                    const resultUrl = new URL(result);

                    // 检查域名是否匹配
                    if (resultUrl.hostname === currentHost) {
                      window.location.href = result;
                    } else {
                      alert("请扫码有效的二维码");
                    }
                  } else {
                    alert("请扫码有效的二维码");
                  }
                } catch (error) {
                  console.error("URL解析错误:", error);
                  alert("请扫码有效的二维码");
                }
              }
            },
            error: function (res) {
              console.log(res);
              alert(res);
              if (res.errMsg.indexOf("function_not_exist") > 0) {
                alert("版本过低请升级");
              }
            },
          }); //wx.scanQRcode结束
        }
      },
      fail: function (res) {
        logger.error("checkJsApi fail " + res);
        //检测getNetworkType该功能失败时处理
        alert("checkJsApi error");
      },
    }); //wx.checkJsApi结束
  }); //wx.ready结束
}

const goToScanCode = function () {
  logger.debug("检查微信环境...");
  if (env.isWxEnv) {
    //wechatUtil.registWx().then(res => callScanQr());
    logger.info("开始调用扫码");
    callScanQr();
  } else {
    alert("请在公众号使用扫码");
  }
};

export default {
  isBlank,
  formatDate,
  formatDateTime,
  formatDateArray,
  formatDateWithoutYear,
  navigate,
  goToScanCode,
};
